import React, { Suspense, useState, useEffect, useRef } from "react";
import systemListingService from "./SystemListingServices";

export default function ProductStatus(param: any) {
  const [editingOn, setEditingOn] = useState(false);
  const [ProductStatus, SetProductStatus] = useState<any>([]);

  useEffect(() => {
    if (param.activeTab === "Product Status") {
      ProductStatusSelect()
    }
  }, [param]);

  const ProductStatusSelect = () => {
    var payload = {}
    systemListingService.statusProductList(payload).then((res:any) => { SetProductStatus(res) });
  }

  return (
    <div className="content-card ws-12">
      {/* Edit tab */}
      <div className="ptl pbl ws-12">
        <span className="text-bold">Product Status</span>
        <button className="icon-btn info pull-right" type="button" onClick={() => setEditingOn((prev) => !prev)}  >
          {editingOn ? "Edit Mode: On" : "Edit Mode: Off"}
        </button>

      </div>

      {/* Table */}
      <div className="table-wrapper">
        <table className={editingOn ? "editing-on newTable" : " newTable"} >
          <thead>
            <tr>
              <th >Status ID</th>
              <th >Status Name</th>
              <th >Short Code</th>
              <th >Song YN</th>
              <th >Track YN</th>
              <th >Release YN</th>
              <th >Cue YN</th>
              <th >Show Hide YN</th>
              <th >Owned YN</th>
              <th >InterCo YN</th>
              <th style={{ width: "17%" }}>Operations</th>
            </tr>
          </thead>
          <tbody>
            {ProductStatus.map((row: any) => (
              <tr key={row.id}>
                <td>{row.productStatusUseID}</td>
                <td>{row.productStatusName}</td>
                <td>{row.ProductStatusShortCode}</td>

                <td>
                  <div className={"pp-switch" + (row?.songYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.trackYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.releaseYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.cueYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.showHideYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.ownedYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td>
                  <div className={"pp-switch" + (row?.interCoYN === 1 ? " on" : "") + (!editingOn ? " disabled" : "")} style={!editingOn ? { opacity: 0.6, pointerEvents: "none" } : {}}   >
                    <div className="pp-knob" />
                  </div>
                </td>

                <td style={{ pointerEvents: editingOn ? "auto" : "none", opacity: editingOn ? 1 : 0.6, cursor: editingOn ? "pointer" : "not-allowed", }}>

                  <button className={`btn-default ${row.isDefault ? "active" : ""}`} type="button" disabled={!editingOn} >
                    Default
                  </button>

                  <button className="icon-btn edit" type="button" disabled={!editingOn} >
                    <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                      <path d="M12 20h9" />
                      <path d="M16.5 3.5a2.1 2.1 0 0 1 3 3L7 19l-4 1 1-4z" />
                    </svg>
                  </button>

                  <button className="icon-btn delete" type="button" disabled={!editingOn}>
                    <i className="icon-trash"> </i>
                  </button>

                </td>

              </tr>
            ))}
          </tbody>
        </table>
      </div>

      {/* Add row button */}
      <div className="add-row-wrapper">
        <button id="addRowBtn" className="btn-add-row" type="button" disabled={!editingOn} >
          <svg width="19" height="19" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth={2} strokeLinecap="round" strokeLinejoin="round" >
            <line x1="12" y1="5" x2="12" y2="19" />
            <line x1="5" y1="12" x2="19" y2="12" />
          </svg>
          Add Product Status
        </button>

        <button id="tableSaveBtn" className="btn-save-table" type="button" disabled={!editingOn} onClick={() => { setEditingOn(false); }} >
          Save Changes
        </button>
      </div>

    </div>
  );
};
